import request from '../axios'

/**
 * @description: 作业用时
 * @param {boolean} ascOrDes 排序顺序,false是降序,true是升序
 * @param {array} cityIDs 城市ID
 * @param {string} endDate 结束日期
 * @param {array} localeIDs 区域ID
 * @param {integer} pageNum 页码
 * @param {integer} pageSize 条数
 * @param {array} provinceIDs 省份ID
 * @param {array} schoolIDs 学校ID
 * @param {string} sortCode 排序字段
 * @param {string} startDate 开始日期
 * @return {*}
 */
export function postHteAnswerTime(data, other = {}) {
  return request({
    url: '/Hte/HteAnswerTime',
    method: 'post',
    data,
    ...other
  })
}
